export const AttendTerms = () => {
  return (
    <>
      본 애플리케이션 이용을 위해 아래 내용을 확인하신 후 동의 여부를 선택해
      주시기 바랍니다.
      <br />
      <br />
      본 애플리케이션은 부산지역 초·중학생의 근골격계 질환 예방을 위한 맞춤형
      건강관리 사업의 일환으로, 부산광역시의 지원을 받아 부산대학교병원에서
      개발하였습니다.
      <br />
      <br />
      본 애플리케이션은 누구나 이용 가능합니다.
      <br />
      <br />
      다만, 본 애플리케이션은 초등학교 5학년부터 중학교 2학년 학생을 주 대상으로
      개발되었으며, 해당 연령 외 이용자의 경우 일부 서비스 내용이 적합하지 않을
      수 있습니다.
      <br />
      <br />
      회원 탈퇴 시, 관련 법령에 따라 개인정보는 지체 없이 파기됩니다.
      <br />
    </>
  );
};

export const UseTerms = () => {
  return (
    <>
      부산대학교병원 및 ㈜인시스템 (이하 '컨소시엄'이라고 합니다) 은
      개인정보보호법 등 관련 법령 상의 개인 정보 보호 규정을 준수하며 귀하의
      개인정보 보호에 최선을 다하고 있습니다. 컨소시엄은 개인정보보호법에
      근거하여 다음과 같은 내용으로 개인정보를 수집 및 처리하고자 합니다.
      <br />
      <br />
      다음의 내용을 자세히 읽어보시고 모든 내용을 이해하신 후에 동의 여부를
      결정해 주시기 바랍니다.
      <br />
      <br />
      <b>제1조(개인정보 수집·이용자) 컨소시엄</b>
      <br />
      <br />
      <b>제2조(개인정보 수집 및 이용 목적)</b>
      <br />
      이용자가 제공한 모든 정보는 다음의 목적을 위해 활용하며, 목적 이외의
      용도로는 사용되지 않습니다.
      <br />◯ 본인확인, 신체정보 확인, 근골격계 평가 확인, 법정대리인(보호자)
      정보 연동 <br />
      <br />
      <b>제3조(개인정보 수집 및 이용 항목)</b>
      <br />
      컨소시엄은 개인정보 수집 목적을 위하여 다음과 같은 정보를 수집합니다.
      <br />
      ◯ 학생: 학교, 학년, 반, 학번, 성명, 성별, 생년월일, 휴대폰 번호, 키,
      몸무게, 척추 상태 등과 그 外 실증 중 수집되는 활동 데이터 <br />
      ◯ 법정대리인(보호자): 성명, 생년월일, 휴대폰 번호 <br />
      <br />
      <b>제4조(개인정보 보유 및 이용 기간)</b>
      <br />
      수집한 개인정보는 수집·이용 동의일로부터  개인정보 수집·이용 목적을 달성할
      때까지  보관 및 이용합니다.
      <br />
      개인정보 보유 기간의 경과, 처리 목적의 달성 등 개인정보가 불필요하게
      되었을 때, 개인회원 탈퇴 및 연구 참여 철회를 요청할 경우에는 지체 없이
      해당 개인정보를 파기합니다.
      <br />
      <br />
      <b>제5조(개인정보 제3자 제공의 경우)</b>
      <br />
      수집된 데이터의 공공활용 등을 위해 부산시가 필요하다고 인정하는 경우
      국가기관 및 공공기관에 제공할 수 있습니다. <br />
      <br />
      <b>제6조(동의 거부 권리)</b>
      <br />
      귀하는 본 안내에 따른 개인정보 수집·이용에 대하여 동의를 거부할 권리가
      있습니다. 다만, 귀하가 개인정보 수집·이용 및 제3자 제공 동의를 거부하시는
      경우에 사업 참여 제한 등의 불이익이 발생할 수 있음을 알려드립니다.
      <br />
      <br />
      <b>제7조(사업 운영 담당자 및 문의)</b>
      <br />
      본 연구에 대해 질문이 있거나 문의가 있을 경우, 연구 담당자(부산대학교병원
      신수화 051-253-3533)로 연락할 수 있습니다.
      <br />
      <br />
      본인은 위의 동의서 내용을 충분히 숙지하였으며, 위와 같이 개인정보를
      수집·이용 및 제3자에게 제공하는데 동의합니다.
    </>
  );
};

export const PhotoTerms = () => {
  return (
    <>
      <span>
        ※ 본 서식에 기재되어 있는 “사진”이란, X-ray 사진이 아닌 실사를 의미하며,
        효율적인 사진정보 수집을 위해 가정에서 휴대폰 카메라로 촬영한 사진을
        해당 앱에 업로드하는 방식입니다.
      </span>
      <br />
      <br />
      <b>1. 사진 활용의 목적 및 필요성</b>
      <br />
      청소년기에 해당되는 학생의 척추측만증의 유무를 평가하기 위해 신체 등
      사진을 활용합니다.
      <br />
      <br />
      <b>2. 과정 및 방법</b>
      <br />
      상의 탈의 후 기립 상태에서의 척추, 자세 변화에 따른 척추의 형태를 촬영하여
      검진 기록에 남기며, 성장 과정상 주요한 변화에 대한 평가를 위해 주기적으로
      반복적인 촬영을 시행합니다. <br />
      <br />
      <b>3. 사진 활용에 대한 동의</b>
      <br />
      질환의 유무 평가를 위한 의료 기록의 일부로써 사진을 활용합니다. 제공된
      사진은 다른 사람에게 알려지지 않도록 비밀로 보장될 것입니다. 다만 의학적
      연구 자료로 사용될 수 있으며, 이 경우 본인의 얼굴이나 신상은 공개되지
      않으며, 익명성은 확실히 보장합니다. <br />
      <br />
      <b>4. 사진 등록 철회 방법</b>
      <br />- 본 애플리케이션의 회원 탈퇴를 통한 사업 참여 철회 시 지체 없이
      사진 등록 철회 및 삭제됩니다.
      <br />
      <br />
      <b>5. 문의처</b>
      <br />- 연구 담당자 : 부산대학교병원 신수화 연구원(051-253-3533)
    </>
  );
};
